import GalaxyAvatar from "@galaxy-io/dls/avatar/Avatar";
import { safeUrl } from "@/lib/utils";
export function RepositoryAvatar({
  owner,
  src,
  size = 28,
}: {
  owner: string;
  src?: string | null;
  size?: number;
}) {
  return (
    <div role="img" aria-label={`${owner} avatar`}>
      <GalaxyAvatar
        img={safeUrl(src) || `https://github.com/${encodeURIComponent(owner)}.png?size=${size * 2}`}
        seed={owner}
        size={size}
      />
    </div>
  );
}
